export const environment = {
    production: false,
    apiUrl: 'https://api-dev-stock.azurewebsites.net/api'
};
